import { useCallback, useState } from "react";
import { useToast } from "./use-toast";

const INITIAL_FORM = { name: "", email: "", phone: "", service: "", message: "" };

const FORMSUBMIT_ENDPOINT = "https://formsubmit.co/ajax/vishal@lmbs.in";

export function validateContactForm(form) {
  if (!form.name?.trim()) return "Please enter your full name.";
  if (!form.email?.trim()) return "Please enter your email address.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return "Please enter a valid email address.";
  if (!form.message?.trim()) return "Please enter a message.";
  return null;
}

function buildPayload(form) {
  return {
    name: form.name,
    email: form.email,
    phone: form.phone || "N/A",
    service: form.service || "N/A",
    message: form.message,
    _subject: `New enquiry from ${form.name} - Lead Matrix Business Solutions`,
    _template: "table",
    _captcha: "false",
  };
}

async function submitToFormSubmit(payload) {
  const response = await fetch(FORMSUBMIT_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  const ok = response.ok && (data.success === "true" || data.success === true);
  return { ok, data };
}

export function useContactForm() {
  const { toast } = useToast();
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);

  const onChange = useCallback((e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, []);

  const resetForm = useCallback(() => setForm(INITIAL_FORM), []);

  const submit = useCallback(async (e) => {
    e.preventDefault();
    const validationError = validateContactForm(form);
    if (validationError) {
      toast({ title: "Missing details", description: validationError, variant: "destructive" });
      return;
    }
    setSubmitting(true);
    try {
      const { ok, data } = await submitToFormSubmit(buildPayload(form));
      if (ok) {
        toast({ title: "Message sent!", description: `Thanks ${form.name}, our team will get back to you shortly.` });
        resetForm();
      } else {
        toast({
          title: "Could not send message",
          description: data.message || "Please try again in a moment or email us directly.",
          variant: "destructive",
        });
      }
    } catch (err) {
      toast({
        title: "Network error",
        description: "Please check your connection and try again.",
        variant: "destructive",
      });
    } finally {
      setSubmitting(false);
    }
  }, [form, toast, resetForm]);

  return { form, submitting, onChange, submit };
}
